module.exports = __webpack_public_path__ + "static/media/sopManager_arrow_up.2916728f.svg";